import { ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import addToTarget from 'rangeConfig/shared/behaviors/addToTarget';

const addLightToTarget = ({ coreApi, props, dispatch, rootState }: BehaviorParameters) => {
  const target = coreApi.entities.findSelectedEntity();

  const lightsOnTarget =
    target && coreApi.entities.findChildWithProductType(target, ProductType.PLATSA_INNER_LIGHT);

  if (target && !lightsOnTarget) {
    addToTarget({ coreApi, props, dispatch, rootState });
  }
};

export default addLightToTarget;
